import { Box, Button, Typography } from '@mui/material'
import EmptyUITestsIcon from '../../../../assets/iconComponents/EmptyUITestsIcon'
import ScanningTestsIcon from '../../../../assets/iconComponents/ScanningTestsIcon'

const UITestsEmpty = ({
  isScanLoading,
  handleScanPage,
  isGenerateTestsInProgress
}) => {
  return (
    <Box className="uiTestingTabEmptyContentContainer">
      { isScanLoading
        ? <Box className='testsEmpty'>
          <Box className='testsScanningIconContainer'>
            <ScanningTestsIcon />
          </Box>
          <Typography className='testsEmptyLabel'>
            Scanning...
          </Typography>
          <Typography className='testsEmptyText'>
            UI scanning is nearly ready
          </Typography>
        </Box>
        : <Box className='testsEmpty'>
          <Box className='testsEmptyIconContainer'>
            <EmptyUITestsIcon />
          </Box>
          <Typography className='testsEmptyLabel'>
            No UI Tests Yet
          </Typography>
          <Typography className='testsEmptyText'>
            Start Visual Testing
          </Typography>
          <Button
            className="testsEmptyActionButton"
            variant="contained"
            color="secondary"
            onClick={handleScanPage}
            disabled={isGenerateTestsInProgress}
          >
            UI SCAN
          </Button>
        </Box>
      }
    </Box>
  )
}

export default UITestsEmpty
